module.exports = __webpack_public_path__ + "static/img/index_bg03.bc0e352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index_bg03.png
// module id = f0W8
// module chunks = 1